import { Component, OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import { ErrorDataService } from '../shared/services/error-data.service';
import { LoggerService } from '../shared/services/logger.service';

@Component({
    selector: 'is-error-500',
    templateUrl: 'error500.component.html',
    standalone: false
})

export class Error500Component implements OnInit {
    public windowReplica = window;
    constructor (private LOGGER: LoggerService, private errorData: ErrorDataService) { }
    ngOnInit(): any {
        if (!this.windowReplica.frameElement) {
            this.LOGGER.error(this.errorData.errorMessage, this.errorData.errorJson);
        }
    }

    callNationwide(): void {
        this.windowReplica.location.href = environment.NATIONWIDE.HOME;
    }
}
